/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MatchOperationV2TeamSide {
    TeamA = 'TEAM_A',
    TeamB = 'TEAM_B'
}


export function instanceOfMatchOperationV2TeamSide(value: any): boolean {
    for (const key in MatchOperationV2TeamSide) {
        if (Object.prototype.hasOwnProperty.call(MatchOperationV2TeamSide, key)) {
            if (MatchOperationV2TeamSide[key as keyof typeof MatchOperationV2TeamSide] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MatchOperationV2TeamSideFromJSON(json: any): MatchOperationV2TeamSide {
    return MatchOperationV2TeamSideFromJSONTyped(json, false);
}

export function MatchOperationV2TeamSideFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationV2TeamSide {
    return json as MatchOperationV2TeamSide;
}

export function MatchOperationV2TeamSideToJSON(value?: MatchOperationV2TeamSide | null): any {
    return value as any;
}

export function MatchOperationV2TeamSideToJSONTyped(value: any, ignoreDiscriminator: boolean): MatchOperationV2TeamSide {
    return value as MatchOperationV2TeamSide;
}

